export default __webpack_public_path__ + "static/media/mob-detail-2.2ea0e5a8.png";